import { render, staticRenderFns } from "./DispatchLayout.vue?vue&type=template&id=55f966cf"
import script from "./DispatchLayout.vue?vue&type=script&lang=js"
export * from "./DispatchLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports